<template lang='pug'>
  .studio
    .studio-left.clearfix(:class='{"unicorn_mode": unicorn_mode}')
      .mobile_wrapper
        landing_page_grid(
          :widgets='sorted_widgets'
          :brand='brand'
          :landing_page="landing_page"
          :retailer='retailer'
          :show_inline_placeholders='true'
          :api_base_path='api_base_path'
          :debug_mode='unicorn_mode'
          :selected_share_id='selected_share_id'
          @widget_edit='edit_widget'
          @widget_delete='delete_widget'
          @widget_add='add_widget'
          @widget_reorder='reorder_widgets'
          v-loading='landing_page_updating'
          ref='landing_page_grid')
    .studio-right
      div.studio-right-sidebar
        el-menu(mode='horizontal', @select='select_tab', default-active='0')
          el-menu-item.studio-right-tabs(v-for='(tab, index) in tabs'
            :key='index'
            :index='index.toString()')
            | {{ tab | remove_underscores }}
        .studio-right-content
          component(
            :landing_page='landing_page'
            :campaign='campaign'
            :campaign_id='campaign_id'
            :brand_id='brand_id'
            :is='current_tab'
            :shares='shares')
      transition(name='fly-in')
        edit(
          v-if='landing_page_widget'
          :campaign="campaign"
          :custom_fields="custom_fields"
          :brand="brand"
          :retailer="retailer"
          :landing_page='landing_page'
          :landing_page_widget='landing_page_widget'
          :selected_share_id='selected_share_id'
          @widget_changed='save_initialized'
          @close='close_edit_panel'
          @refresh_edit_panel='edit_widget'
          @change_selected_share='change_selected_share')
</template>

<script>
  import _ from 'lodash'
  import Cookies from 'js-cookie'
  import axios from 'axios'
  import { db, api_base_path, auth } from '../utils/firebase'
  import widgets from './widgets.vue'
  import settings from './settings.vue'
  import edit from './edit.vue'

  const mock_retailer = {
    brand_id: 1,
    created_at: "2018-08-08 20:11:27 UTC",
    created_by_id: 6,
    email: "support@promoboxx.com",
    deleted_at: null,
    hash_id: null,
    id: 2580,
    location_count: 2,
    locations: [
      {
        addr1: "{{ Retailer Address }}",
        addr2: "{{ Retailer Address 2 }}",
        city: "{{ Retailer City }}",
        country_code: "US",
        google_place_id: "ChIJJxX8JVaPmIcRsyJr2fpjV94",
        id: 123456,
        latitude: "39.8283",
        longitude: "-98.5795",
        phone: "{{ Retailer Phone }}",
        state: "{{ Retailer State }}",
        website: "https://www.promoboxx.com/",
        zip: "{{ Retailer Zip }}"
      }
    ],
    logo_url: "https://www.techonline.com/img/tmp/logo-placeholder.png",
    name: "{{ Retailer.Name }}",
    phone: "6175555555",
    website: "https://www.promoboxx.com",
    facebook_pages: [
      {
        link: 'https://www.facebook.com/promoboxx/'
      }
    ],
    twitter_accounts: [
      {
        url: 'http://twitter.com/promoboxx'
      }
    ]
  }

  export default {
    name: 'studio',
    components: {
      edit,
      widgets,
      settings
    },
    props: {
      unicorn_mode: {
        type: Boolean,
        required: false
      },
      shares: {
        type: Array,
        required: false
      },
      selected_share_id: {
        type: String,
        required: false,
        default: ''
      }
    },
    inject: {
      $validator: '$validator'
    },
    data() {
      return {
        retailer: mock_retailer,
        locations: mock_retailer.locations,
        brand: {},
        campaign: {},
        landing_page: {},
        landing_page_widget: null,
        landing_page_widgets: [],
        custom_fields: [],
        current_tab: 'widgets',
        tabs: [ 'widgets', 'settings' ],
        landing_page_updating: false,
        api_base_path: api_base_path
      }
    },
    firestore() {
      return {
        brand: db.doc(`brands/${this.brand_id}`),
        custom_fields: db.collection(`brands/${this.brand_id}/custom_fields`),
        campaign: db.doc(`brands/${this.brand_id}/campaigns/${this.campaign_id}`),
        landing_page: db.doc(`landing_pages/${this.campaign_id}`),
        landing_page_widgets: db.collection(`landing_pages/${this.campaign_id}/landing_page_widgets`)
      }
    },
    filters: {
      remove_underscores(name) {
        return name.replace(/_/g, ' ')
      }
    },
    computed: {
      campaign_id() {
        return this.$route.params.campaign_id
      },
      brand_id() {
        return this.$route.params.brand_id
      },
      sorted_widgets() {
        return _.sortBy(this.landing_page_widgets, 'index')
      },
    },
    methods: {
      save_initialized() {
        this.$emit('save_initialized')
      },
      edit_widget(widget) {
        this.close_edit_panel()
        this.$nextTick(function() {
          this.landing_page_widget = widget
        })
      },
      close_edit_panel() {
        this.landing_page_widget = null
      },
      async add_widget(widget) {
        this.save_initialized()
        const batch = db.batch()
        let widget_dropped = await db.collection('widgets').doc(widget.widget_id).get()
        widget_dropped = widget_dropped.data()
        this.landing_page_widgets.forEach(current_widget => {
          if(current_widget.index > widget.widget_index){
            const ref = db.collection(`landing_pages/${this.campaign_id}/landing_page_widgets`).doc(current_widget.id)
            batch.update(ref, { index: + current_widget.index + 1 })
          }
        })
        this.add_timestamp(batch)
        await batch.commit()
        let newWidget = db.collection(`landing_pages/${this.campaign_id}/landing_page_widgets`).doc()
        const new_widget_id = newWidget.id;
        const created_widget = {
          id: new_widget_id,
          index: parseInt(widget.widget_index) + 1,
          draft_content: widget_dropped.content,
          widget: widget_dropped
        }
        if (created_widget.widget.name === 'shares') {
          let shares_data = []
          this.shares.forEach(share => {
            let share_data = {
              id: share.id,
              name: share.name,
              image_url: share.responsive_share_image_url,
              type: share.share_type
            }
            switch(share.share_type) {
              case 'facebook':
                const copy = share.share_setting_copy_options.length > 0 ? share.share_setting_copy_options[share.share_setting_copy_options.length - 1].message : ''
                share_data.copy = `<p>${copy}</p>` // 'Suggested Copy 1' in CP
                break
              case 'twitter':
                share_data.copy = `<p>${share.body}</p>` // 'Tweet' in CP
                break
              case 'instagram':
                share_data.copy = `<p>${share.caption}</p>` // 'Caption' in CP
                break
              case 'email':
                share_data.copy = share.description // 'Body Copy' in CP
                break
              default:
                share_data.copy = '<p></p>'
                break
            }
            shares_data.push(share_data)
          })
          created_widget.draft_content.shares = shares_data
        }
        newWidget.set(created_widget)
        this.landing_page_widget = created_widget
      },
      async delete_widget(landing_page_widget) {
        this.save_initialized()
        const { id,index } = landing_page_widget
        const batch = db.batch()
        await db.collection(`landing_pages/${this.campaign_id}/landing_page_widgets`).doc(id).delete()
        this.landing_page_widgets.forEach(current_widget => {
          if (current_widget.index >= index) {
            const ref = db.collection(`landing_pages/${this.campaign_id}/landing_page_widgets`).doc(current_widget.id)
            batch.update(ref,{index: +current_widget.index-1})
          }
        })
        this.add_timestamp(batch)
        batch.commit()
        this.landing_page_widget = null
      },
      select_tab(index) {
        this.current_tab = this.tabs[index].toLowerCase()
      },
      reorder_widgets(widget_ids) {
        this.save_initialized()
        const batch = db.batch()
        const db_refs = widget_ids.map(id => db.collection(`landing_pages/${this.campaign_id}/landing_page_widgets`).doc(id))
        db_refs.forEach((ref,index) => batch.update(ref, {index}))
        this.add_timestamp(batch)
        batch.commit()
      },
      add_timestamp(batch) {
        const page_ref = db.doc(`landing_pages/${this.campaign_id}`)
        batch.update(page_ref, {updated_at: new Date()})
      },
      change_selected_share(share_id) {
        this.$emit('change_selected_share', share_id)
      }
    }
  }
</script>

<style lang='scss'>
  @import 'compass-mixins';
  @import "@promoboxx/pbxx2component/src/styles/variables_and_mixins";
  $header_height: 51px;
  .studio {
    margin-top: $header_height;
    font-family: "gotham-round";
    height: calc(100% - 51px);
    background-color: #f0f0f0;
    &-left {
      background-color: #f0f0f0;
      width: calc(100% - 400px); // 100% - right-col.width
      min-height: calc(100vh - 51px);
      & .mobile_wrapper {
        position: relative;
        border-radius: 22px;
        background: #F0F0F0;
        width: 450px;
        margin: 50px auto 0;
        border-top: 20px solid black;
        background-image: -webkit-gradient(linear, 0 0, 0 100%, from(#000), to(transparent));
        background-image: -webkit-linear-gradient(#000, transparent);
        background-image: -moz-linear-gradient(#000, transparent), -moz-linear-gradient(#000, transparent);
        background-image: -o-linear-gradient(#000, transparent), -o-linear-gradient(#000, transparent);
        background-image: linear-gradient(#000, transparent), linear-gradient(#000, transparent);
        -moz-background-size: 10px 50%;
        background-size: 10px 50%;
        background-position: 0 0, 100% 0;
        background-repeat: no-repeat;
        & .grid {
          width: 90%;
          margin-top: 30px;
          border: 1px black solid;
        }
      }
    }
    &-right {
      position: fixed;
      top: $header_height;
      right: 0;
      bottom: 0;
      width: 450px;
      background-color: get-color(white);
      @include box-shadow(-3px 0 3px -3px get-color(gray-light));
      &-tabs {
        text-align: center;
        text-transform: capitalize;
        width: 50%;
      }
      &-content {
        height: calc(100% - 61px); // 100% - studio-tabs.height
        overflow: scroll;
      }
      &-sidebar {
        height: 100%;
      }
    }
  }
  .edit {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: 450px;
    background: white;
  }
  .fly-in-enter-active,
  .fly-in-leave-active {
    @include transition-property(right);
    @include transition-duration(0.4s);
  }

  .fly-in-enter,
  .fly-in-leave-to {
    right: -400px;
  }

  // Easter Egg
  .unicorn_mode {
    background: linear-gradient(-45deg, #EE7752, #E73C7E, #23A6D5, #23D5AB);
    background-size: 400% 400%;

    -webkit-animation: unicorn_mode 4s ease infinite;
    -moz-animation: unicorn_mode 4s ease infinite;
    animation: unicorn_mode 4s ease infinite;

    @-webkit-keyframes unicorn_mode {
        0%{background-position:0% 50%}
        50%{background-position:100% 50%}
        100%{background-position:0% 50%}
    }
    @-moz-keyframes unicorn_mode {
        0%{background-position:0% 50%}
        50%{background-position:100% 50%}
        100%{background-position:0% 50%}
    }
    @keyframes unicorn_mode {
        0%{background-position:0% 50%}
        50%{background-position:100% 50%}
        100%{background-position:0% 50%}
    }
  }
</style>
